const KEY = 'flowqa:upload-toast-intents';

const readIds = (): Set<string> => {
  if (typeof window === 'undefined') {
    return new Set();
  }
  const raw = window.sessionStorage.getItem(KEY);
  if (!raw) return new Set();
  try {
    const parsed: unknown = JSON.parse(raw);
    if (!Array.isArray(parsed)) return new Set();
    return new Set(parsed.filter((value): value is string => typeof value === 'string'));
  } catch {
    return new Set();
  }
};

const writeIds = (ids: Set<string>): void => {
  if (typeof window === 'undefined') {
    return;
  }
  window.sessionStorage.setItem(KEY, JSON.stringify(Array.from(ids)));
};

export const markUploadToastIntent = (uploadId: string): void => {
  const trimmed = uploadId.trim();
  if (!trimmed) return;
  const ids = readIds();
  ids.add(trimmed);
  writeIds(ids);
};

export const consumeUploadToastIntent = (uploadId: string): boolean => {
  const trimmed = uploadId.trim();
  if (!trimmed) return false;
  const ids = readIds();
  if (!ids.has(trimmed)) {
    return false;
  }
  ids.delete(trimmed);
  writeIds(ids);
  return true;
};
